import { render, staticRenderFns } from "./FormAcreditacion.vue?vue&type=template&id=45af5530"
import script from "./FormAcreditacion.vue?vue&type=script&lang=js"
export * from "./FormAcreditacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports